import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    const timeout = this.timeoutValue || 4000
    this.timeoutId = setTimeout(() => this.dismiss(), timeout)
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  dismiss() {
    this.element.classList.add("opacity-0")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    setTimeout(() => {
      if (this.element.isConnected) {
        this.element.remove()
      }
    }, 350)
  }
}
